export default __webpack_public_path__ + "static/media/char_body_prem_009.1fd17422.png";